import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import FETCH from '../Fetch';
import { toast } from './Notifier';
import AccommodationsLoader from '../loaderComponents/AccommodationsLoader';
import { numberFormat } from '../utils';

class EmptyAccommodations extends React.Component {
  render() {
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1 className="small">Error</h1>
        {/* card for registered courses display  */}
        <div className="row no-gutters">
          <div className="col-lg-12 ">
            <div className="card row justify-content-center align-items-center min-h-500 not-found">
              <div className="status-code"> Sorry </div>
              <div className="status-text">
                {' '}
                {this.props.message
                  ? this.props.message
                  : 'Server could not be reached, check network connectivity'}
              </div>
              <Link
                className="btn btn-primary btn-primary-color not-found-btn"
                to="/fees"
              >
                Fees
              </Link>
            </div>
            {/* card for outstanding fees */}
          </div>
        </div>
        {/* end card for news display   */}
      </main>
    );
  }
}

class Accommodations extends React.Component {
  state = {
    accommodations: null
  };
  componentDidMount() {
    FETCH.getAccmodations()
      .then(async res => {
        if (res.status === 'error') {
          toast(
            res.message
              ? res.message
              : 'Server could not be reached, check network connectivity',
            { status: 'error', timeout: 2000 }
          );
          this.setState({
            accommodations: null,
            error: true,
            message: res.message
          });
          return;
        }
        this.setState({
          accommodations: this.modifiedAccomodationsData(res.data)
        });
      })
      .catch(err =>
        toast(
          err.messge
            ? err.message
            : 'Server could not be reached, check network connectivity',
          { status: 'error' }
        )
      );
  }

  /*
   *  if user has booked an apartment, place that apartment on the top of the array
   */
  modifiedAccomodationsData = hostelArray => {
    let newHostelArray = hostelArray;
    // check for booked and hostel
    let bookedHostel = newHostelArray.find(
      hostel => hostel.is_booked === 1 && hostel.can_be_disabled === 0
    );

    // return same list if no hotel is booked
    if (!bookedHostel) return newHostelArray;

    // strip out booked hostel from the list
    newHostelArray = newHostelArray.filter(
      x => x.hostel_id !== bookedHostel.hostel_id
    );

    // push booked hostel to top of the list
    newHostelArray.unshift(bookedHostel);
    return newHostelArray;
  };

  handleLinkClick = (notBooked, id) => {
    if (!notBooked) {
      this.props.history.push(`/accomodation/details/${id}`);
    } else {
      return;
    }
  };

  render() {
    return this.state.error ? (
      <EmptyAccommodations message={this.state.message} />
    ) : (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1>Accomodation</h1>
        {/*  container for accommodation cards  */}
        <div className="row justify-content-center align-items-center">
          {this.state.accommodations ? (
            this.state.accommodations.map((item, i) => (
              <AccommdationCard
                details={item}
                key={i}
                can_be_disabled={item.can_be_disabled === 1}
                handleLinkClick={this.handleLinkClick}
              />
            ))
          ) : (
            <>
              <AccommodationsLoader /> <AccommodationsLoader />{' '}
              <AccommodationsLoader />
            </>
          )}
        </div>
      </main>
    );
  }
}

class AccommdationCard extends Component {
  render() {
    return (
      <div
        className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 ${
          this.props.can_be_disabled ? 'disabled-div' : null
        }`}
      >
        {/* card for accomodation */}
        <div className="card min-h-200">
          <div className="card-body row no-gutters accommodation-list p-0">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
              <img
                src={require('../assets/accomdation-image.png')}
                alt="hostel immage"
                className="hostel-image"
              />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
              <div className="row content">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                  <div className="justify-content-around align-items-start">
                    <div className="title-description">
                      <div className="title">
                        {this.props.details.hostel_name}
                      </div>
                      <div className="description">
                        {this.props.details.address},
                        <span> {this.props.details.location} </span>
                      </div>
                    </div>
                    <div className="bedspace-info">
                      <span>
                        {' '}
                        <img
                          src={require('../assets/bed-space.svg')}
                          alt="bed icon"
                        />
                      </span>{' '}
                      <span className="bedspace-info-text">
                        {' '}
                        {this.props.details.total_bed_spaces}{' '}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <div className="price-info ">
                    <div className="price-duration">
                      <div className="price">
                        {numberFormat(this.props.details.amount)} NGN
                      </div>
                      <div className="duration">PER SESSION</div>
                    </div>
                    <div className="text-right">
                      <a
                        className="btn btn-primary btn-primary-color"
                        onClick={e => {
                          e.preventDefault();
                          this.props.handleLinkClick(
                            this.props.can_be_disabled,
                            this.props.details.hostel_id
                          );
                        }}
                      >
                        {this.props.details.is_booked === 0
                          ? ' View Space'
                          : ' View Booking'}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  end card for accomdation */}
      </div>
    );
  }
}
export default withRouter(Accommodations);
